//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PostSubmitInBackground: FeatureFlag = {"Id":"PostSubmitInBackground","Label":"(Technical)PostSubmitInBackground","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Run the post submission process in background","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
